import React from 'react';
import styles from './LoadingSpinner.module.css';

export const LoadingSpinner = ({ small, light }) => (
  <section className={`${styles.loadingSpinner} ${small ? styles.small : ''} ${light ? styles.light : ''}`}>
    <div className={styles.ldsRing}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </section>
);

export default LoadingSpinner;
